/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = None

1 = Some


 */
export type ProposalSignatureRequirement =
  (typeof ProposalSignatureRequirement)[keyof typeof ProposalSignatureRequirement];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProposalSignatureRequirement = {
  None: 0,
  Some: 1,
} as const;
